import React from "react";
import { useTranslation } from "react-i18next";
import { RenderIf } from "shared/components";
import Member from "shared/media/user/userIcon.png";
import { Received } from "shared/components/Icons";
import "./Card.scss";
const { REACT_APP_BASE_PHOTO_URL_MAIN } = process.env;

const TeamCard = ({
  img,
  firstName,
  lastName,
  position,
  description,
  rating,
  handleClick,
  fullHover,
  isKey,
  zoomInOut,
  isHaveModal,
  field,
}) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={handleClick}
      className={`${handleClick ? "teamCardMain cursor" : "teamCardMain"} ${
        fullHover ? "fullHover" : ""
      }${zoomInOut ? "zoomInOut" : ""}`}>
      <RenderIf condition={rating || rating === 0}>
        <div className="teamCardMainRating">{rating}</div>
      </RenderIf>
      <RenderIf
        condition={!isKey}
        renderElse={<img className="w-100" alt="user img" src={img} />}>
        <img
          className="w-100"
          alt="user img"
          src={img ? `${REACT_APP_BASE_PHOTO_URL_MAIN}${img}` : Member}
        />
      </RenderIf>
      <div className="teamCardMainText w-100">
        <RenderIf condition={field}>
          <span className="teamCardMainBottomTopic">{t("trainingTopic")}:</span>
        </RenderIf>

        <div className="d-flex justify-content-between align-items-center">
          <h4>
            {firstName} {lastName}
          </h4>
          <Received />
        </div>
        <RenderIf condition={fullHover}>
          <RenderIf condition={description}>
            <p
              className="mt-2"
              dangerouslySetInnerHTML={{
                __html: description,
              }}></p>
          </RenderIf>
        </RenderIf>

        <div className="innerTextDiv">
          <RenderIf condition={field}>
            <span className="teamCardMainBottom pb-0">
              <span className="teamCardMainBottomTopic">
                {t("businessArea")}:
              </span>
              {field}
            </span>
          </RenderIf>
          <RenderIf condition={position}>
            <span>{position}</span>
          </RenderIf>
          <RenderIf condition={description}>
            <p
              dangerouslySetInnerHTML={{
                __html: description,
              }}></p>
          </RenderIf>
          <RenderIf condition={isHaveModal}>
            <button className="teamCardMainBottom">{t("findMore")}</button>
          </RenderIf>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
